import { Link } from 'react-router-dom';
import type { VideoItem } from '@/mocks/videos';

interface VideoCardProps {
  video: VideoItem;
}

export default function VideoCard({ video }: VideoCardProps) {
  const formatViews = (views: number): string => {
    if (views >= 10000) {
      return (views / 10000).toFixed(1) + '万';
    }
    return views.toString();
  };

  return (
    <Link
      to={`/article/${video.id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover-lift"
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={video.cover}
          alt={video.title}
          title={`${video.title} - 密桃视频免费在线观看`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
          <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-primary-500/90 backdrop-blur-sm">
            <i className="ri-play-fill text-background-50 text-2xl md:text-3xl ml-0.5"></i>
          </div>
        </div>
        <div className="absolute top-3 right-3 bg-black/70 backdrop-blur-sm text-background-50 text-xs px-2 py-1 rounded-md font-label whitespace-nowrap">
          {video.quality}
        </div>
        <div className="absolute bottom-3 right-3 bg-black/70 backdrop-blur-sm text-background-50 text-xs px-2 py-1 rounded-md font-label whitespace-nowrap">
          {video.duration}
        </div>
        <div className="absolute top-3 left-3">
          <span className="bg-primary-500 text-background-50 text-xs px-2 py-1 rounded-md font-label whitespace-nowrap">
            {video.rating}
          </span>
        </div>
      </div>
      <div className="p-3 md:p-4">
        <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 line-clamp-2 mb-2 group-hover:text-primary-600 transition-colors duration-200">
          {video.title}
        </h3>
        <div className="flex items-center justify-between text-xs text-foreground-400">
          <span className="flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {formatViews(video.views)}
          </span>
          <span className="flex items-center gap-1 text-accent-600">
            <i className="ri-links-line"></i>
            {video.source}
          </span>
        </div>
        <div className="flex flex-wrap gap-1.5 mt-2.5">
          {video.tags.slice(0, 3).map((tag) => (
            <span
              key={tag}
              className="text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 whitespace-nowrap"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}